/**
 * Inventory Store
 *
 * @since 2021-11-18
 * @author Jaeuk Ryu <wj_tams_dev02>
 *
 */
import {SystemApiPrefix as apiPrefix} from '~/utils/restApi'

const initLogMgmtPageData = () => {
  return {
    syslog_send_addr_1: '',
    syslog_send_desc_1: '',
    syslog_send_use_yn_1: 0,
    syslog_send_port_1: 514,
    syslog_send_func_1: 14,
    syslog_send_form_1: 1,
    syslog_send_addr_2: '',
    syslog_send_desc_2: '',
    syslog_send_use_yn_2: 0,
    syslog_send_port_2: 514,
    syslog_send_func_2: 14,
    syslog_send_form_2: 1,
    syslog_send_addr_3: '',
    syslog_send_desc_3: '',
    syslog_send_use_yn_3: 0,
    syslog_send_port_3: 514,
    syslog_send_func_3: 14,
    syslog_send_form_3: 1
  }
}
export const state = () => ({
  url: `${apiPrefix}/external/syslog`,
  defaultList: initLogMgmtPageData(),
  newDefaultList: []
})

export const mutations = {
  setAutoSendData (state, payload) {
    const newObj = []
    for (let i = 1; i <= 3; i++) {
      newObj.push({
        syslog_send_addr: payload[`syslog_send_addr_${i}`],
        syslog_send_desc: payload[`syslog_send_desc_${i}`],
        syslog_send_use_yn: payload[`syslog_send_use_yn_${i}`],
        syslog_send_port: payload[`syslog_send_port_${i}`],
        syslog_send_func: payload[`syslog_send_func_${i}`],
        syslog_send_form: payload[`syslog_send_form_${i}`],
        syslog_server_name: `서버 ${i}`
      })
    }
    state.newDefaultList = newObj
  }
}

export const actions = {
  async checkConnection ({commit}, {target}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$get(`/api/co/tools/connect?target=${encodeURIComponent(target)}`)
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  // Syslog 설정 조회
  async getSysLogData ({commit, state}) {
    try {
      let res = {
        code: 'ok',
        result: {}
      }
      res = await this.$axios.$get(state.url, {loading: false, successAlert: false})
      if (res.code === 'ok') {
        commit('setAutoSendData', res.result[0])
      }
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 로그 설정 적용
  async applySettings ({commit, state}, payload) {
    const apiUrl = `${state.url}/apply`
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const param = payload
      res = await this.$axios.$put(apiUrl, param, {applyMsg: true})
    } catch (error) {
      res.code = 'nok'
      res.result.msg = error.message
    }
    return res
  },
  // 로그 설정 취소
  async cancelSettings ({commit, state}) {
    const apiUrl = `${state.url}/cancel`
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$put(apiUrl, null, {cancelMsg: true})
    } catch (error) {
      res.code = 'nok'
      res.result.msg = error.message
    }
    return res
  }
}
